import debounce from 'lodash/debounce';

import InfiniteLoader from '~/components/GraphInfiniteLoader';
import SearchTextField from '~/components/SearchTextField';
import { SidebarContent } from '~/components/Sidebar';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '~/components/Table';

import Pageview from './Pageview';

class Pageviews extends React.Component {
  state = {
    path: '',
  };

  setFilter = (filter) => {
    let path = filter;
    if (path && path[0] !== '/') path = `/${path}`;

    this.setState({ path });
    this.onFilter(path);
  };

  onFilter = debounce((path) => this.props.onFilter(path), 300);

  render = () => {
    const { path } = this.state;
    const {
      events,
      hasNextPage,
      onLoadMore,
      loading,
      loadingMore,
    } = this.props;

    return (
      <SidebarContent>
        <SearchTextField
          placeholder="Search by path..."
          fullWidth
          onSearch={(e) => this.setFilter(e.target.value)}
          value={path}
        />
        <Table sidebar>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Page</TableCell>
              <TableCell>Time</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <InfiniteLoader
              emptyBody="Nothing to show"
              hasNextPage={hasNextPage}
              loading={loading}
              loadingMore={loadingMore}
              nodes={events}
              onLoadMore={onLoadMore}
              rowHeight={58}
              rowRenderer={(event, index, style) => (
                <div key={event.id} role="listitem" style={style}>
                  <Pageview key={event.id} event={event} />
                </div>
              )}
            />
          </TableBody>
        </Table>
      </SidebarContent>
    );
  };
}

Pageviews.defaultProps = {
  events: {
    pageInfo: {
      hasNextPage: false,
    },
  },
};

Pageviews.propTypes = {
  id: PropTypes.string.isRequired,
  events: PropTypes.array.isRequired,
  onFilter: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  hasNextPage: PropTypes.bool,
  loadingMore: PropTypes.bool.isRequired,
};

export default Pageviews;
